// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2y5TJ","choiceBoxes":"toolbarselects_choiceBoxes__D3efM","simpleField":"toolbarselects_simpleField__2EMTk"};